import { memo, useEffect } from 'react'
import { Snackbar, Alert, Typography } from '@mui/material'

function WellbeingToast({ open, message, onClose }) {
	useEffect(() => {
		if (!open) return undefined
		const t = setTimeout(() => onClose?.(), 4200)
		return () => clearTimeout(t)
	}, [open, onClose])

	return (
		<Snackbar
			open={Boolean(open && message)}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			onClose={onClose}
		>
			<Alert
				onClose={onClose}
				severity='success'
				icon={<span aria-hidden>🌿</span>}
				sx={{
					borderRadius: '16px',
					alignItems: 'center',
					bgcolor: '#F5F3FF',
					color: '#1E1B4B',
					border: '1px solid #DDD6FE',
					boxShadow: '0 12px 30px rgba(15, 23, 42, 0.12)',
					'& .MuiAlert-icon': { color: '#5B4BDB' },
				}}
			>
				<Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
					{message}
				</Typography>
			</Alert>
		</Snackbar>
	)
}

export default memo(WellbeingToast)
